import type { LeaveTypeId } from '@lms/shared-types'
import { apiRequest } from './client'

export interface LeaveTypeMetadata {
  id: LeaveTypeId
  label: string
  color: string
  halfDayAllowed: boolean
  documentRequired: boolean
  description: string
  defaultEntitlement: number | null
  fixedDurationDays: number | null
  probationRestricted: boolean
  /** When false, advance-booking window cap does not apply — the type is
   *  retrospective (medical, compassionate). */
  bookableInAdvance: boolean
}

export function listLeaveTypes(): Promise<LeaveTypeMetadata[]> {
  return apiRequest<LeaveTypeMetadata[]>('/api/v1/leave-types')
}
